import { Stack } from "expo-router";
import { View } from "@src/components";
import { useState } from "react";
import AiFloatingActionButton from "@src/components/AiFloatingActionButton";
import { FeatureGate } from "@src/services/feature-flags/FeatureGate";
import { FEATURE_FLAGS } from "@src/services/feature-flags/feature-flags";
import { RequireCameraKey } from "@src/components/web/RequireCameraKey.web";
import { WebLayout } from "@src/components/web/WebLayout.web";
import { AgentSidePanel } from "@src/components/web/AgentSidePanel.web";
import { TimetableSidePanel } from "@src/components/web/TimetableSidePanel.web";
import { AlarmSettingsContent } from "@src/components/web/AlarmSettingsContent.web";

export default function CameraAlarmScreen() {
  const [isAgentPanelOpen, setIsAgentPanelOpen] = useState(false);

  return (
    <RequireCameraKey requireSiteId>
      {({ cameraKey, siteId: effectiveSiteId }) => (
        <>
          <Stack.Screen options={{ headerShown: false }} />
          <WebLayout
            rightPanel={
              isAgentPanelOpen ?
                <AgentSidePanel onClose={() => setIsAgentPanelOpen(false)} />
              : <TimetableSidePanel cameraKey={cameraKey} siteId={effectiveSiteId} />
            }
          >
            <View flex={1}>
              <AlarmSettingsContent cameraKey={cameraKey} siteId={effectiveSiteId} showConfigSections={false} />
              <FeatureGate flag={FEATURE_FLAGS.AI_SCHEDULER}>
                <AiFloatingActionButton onPress={() => setIsAgentPanelOpen(true)} />
              </FeatureGate>
            </View>
          </WebLayout>
        </>
      )}
    </RequireCameraKey>
  );
}
